// frontend/src/components/basemaps.js
// 🗺️ Alaptérkép-források EGY helyen — ha egy szolgáltató változtat a feltételein,
//    elég ezt a fájlt módosítani, nem kell az oldalakat végigjárni.
//
// 🔴 VÁLTÁS-TÖRTÉNET
//    2026-08: a CARTO ingyenes raszter-csempéi API-kulcshoz kötöttek lettek, és
//      kulcs nélkül átlós „API KEY REQUIRED" vízjellel szolgálták ki a képeket.
//      Innen váltottunk az OpenStreetMap hivatalos csempéire.
//    2026-09: az OSM letiltotta a hozzáférést („Access blocked — App is not
//      following the tile usage policy"). Ez nem üzemzavar volt: az OSM
//      házirendje kimondja, hogy az önkéntesek üzemeltette csempeszerverei NEM
//      harmadik féltől származó alkalmazásoknak valók.
//
//    A tanulság mindkét esetben ugyanaz: olyan infrastruktúrát használtunk,
//    aminek nem voltunk ügyfelei. Ezért most a Stadia Maps ingyenes csomagjára
//    váltunk, ahol regisztrált felhasználók vagyunk ismert korlátokkal — ez nem
//    tud egyik napról a másikra, előzetes jelzés nélkül elfogyni alólunk.
//
// 🔑 HITELESÍTÉS: a Stadia domain-alapú engedélyezést támogat, ezért az URL-ben
//    NINCS kulcs. Ez fontos: a frontend csomag bárki számára olvasható, aki
//    betölti a dashboardot, tehát kulcsot nem is volna szabad beleégetni.
//    A dashboard.aitourmate.hu domaint a Stadia fiókban kell engedélyezni.
//
//    Ha valamiért mégis kulcsos hitelesítés kell (pl. más domainről is nézni),
//    a REACT_APP_STADIA_KEY build-időbeli env változóval megadható — ilyenkor
//    a kulcs bekerül a csomagba, ezért a Stadia fiókban akkor is érdemes
//    domainre korlátozni.

const KEY = process.env.REACT_APP_STADIA_KEY || '';
const AUTH = KEY ? `?api_key=${KEY}` : '';

// A {r} helyőrzőt a Leaflet cseréli ki "@2x"-re retina kijelzőn. Enélkül a
// térkép elmosódott a nagy felbontású laptopokon/telefonokon.
const tiles = (style) => `https://tiles.stadiamaps.com/tiles/${style}/{z}/{x}/{y}{r}.png${AUTH}`;

// 🆕 A sötét változat mostantól NATÍV stílus, nem CSS-szűrővel előállított.
//    Korábban a világos csempéket fordítottuk meg (invert + hue-rotate), ami
//    olvasható volt, de a színek hamisak lettek (a víz lilás, a zöld terület
//    barnás). Az alidade_smooth_dark eleve sötétnek készült.
export const TILE_URL = tiles('alidade_smooth_dark');
export const TILE_URL_LIGHT = tiles('alidade_smooth');

export const TILE_ATTRIBUTION =
  '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, '
  + '&copy; <a href="https://openmaptiles.org/">OpenMapTiles</a>, '
  + '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> közreműködők';
